import React, { useState, useEffect, useCallback } from "react";
import AsyncSelect from "react-select/async";
import { getCountry } from "app/services/hotel/hotelService";
import queryStringService from "app/services/queryStringService";

const CountryAutoComplete = ({ setFieldValue }) => {
  const [selectedValue, setSelectedValue] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [defaultOptions, setDefaultOptions] = useState([]);

  // Load options using API call
  const fetchInitialOptions = async () => {
    const query = queryStringService.getQueryStringFromObj({
      searchText: "india", // initially empty
    });

    const { data } = await getCountry(query);
    const options =
      data?.data?.map((item) => ({
        id: item.id,
        label: `${item.name.toUpperCase()}`,
        countryid: item.countryid,
        code: item.code,
      })) || [];

    setDefaultOptions(options);

    // Auto-select the first option
    if (options.length > 0) {
      setSelectedValue(options[0]);
      setFieldValue("searchCriteria.countryId", options[0].id);
      setFieldValue("searchCriteria.countryName", options[0].label);
      setFieldValue("searchCriteria.nationality", options[0].countryid);
      setFieldValue("address.country.code", options[0].code);
      setFieldValue("address.country.name", options[0].label);
      setFieldValue("address.cn", options[0].label);
    }
  };

  useEffect(() => {
    fetchInitialOptions();
  }, []);

  // Called when the user types in the input
  const handleInputChange = (value) => {
    setInputValue(value);
  };

  // Called when an option is selected
  const handleChange = (value) => {
    setSelectedValue(value);
    setFieldValue("searchCriteria.countryId", value.id);
    setFieldValue("searchCriteria.countryName", value.label);
    setFieldValue("searchCriteria.nationality", value.countryid);
    setFieldValue("address.country.code", value.code);
    setFieldValue("address.country.name", value.label);
    setFieldValue("address.cn", value.label);
  };

  // Loads async options based on input
  const loadOptions = useCallback(async (value) => {
    const inputValue = value.trim().toLowerCase();

    const query = queryStringService.getQueryStringFromObj({
      searchText: inputValue,
    });

    const { data } = await getCountry(query);

    return (
      data?.data?.map((item) => ({
        id: item.id,
        label: `${item.name.toUpperCase()}`,
        countryid: item.countryid,
        code: item.code,
      })) || []
    );
  }, []);

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions={defaultOptions}
      value={selectedValue}
      getOptionLabel={(e) => e.label}
      getOptionValue={(e) => e.id}
      loadOptions={loadOptions}
      onInputChange={handleInputChange}
      onChange={handleChange}
      name="searchCriteria.countryId"
      placeholder="Select Country Name"
    />
  );
};

export default CountryAutoComplete;
